export default __webpack_public_path__ + "static/media/Lightning.66f86fd6.svg";